import MLClickToChatDataService from './MLClickToChatDataService';

const debugMode = true;
let chatEnabled = false;
const displayHelpButton = true;
const language = 'en-US'; // en-US by default
const storageDomain = MLClickToChatDataService.getStorageDomain();
let app = 'QB';  // SET QB BY DEFAULT

export default {
    isChatEnabled: () => {
        return chatEnabled;
    },

    setChatEnabled: (enabled) => {
        chatEnabled = enabled;
    },

    getAgentType: (agentType) => {
        return MLClickToChatDataService.getAgentType(agentType);
    },

    getChatData: () => {
        return window.embedded_svc.settings.prepopulatedPrechatFields;
    },

    setChatData: (data, portal) => {
        if (portal) {
            app = portal;
        }
        data = Object.assign(MLClickToChatDataService.getPrepopulatedPrechatFields(app), data);
        if (window.embedded_svc) {
            window.embedded_svc.settings.prepopulatedPrechatFields = data;
        } else {
            MLClickToChatDataService.store(data);
        }
    },

    updateAgentCode: (data) => {
        data = Object.assign(MLClickToChatDataService.getPrepopulatedPrechatFields('GPA'), data);
        if (window.embedded_svc) {
            window.embedded_svc.settings.prepopulatedPrechatFields = data;
        } else {
            MLClickToChatDataService.store(data);
        }
    },

    init: (p, c, auth) => {
        MLClickToChatDataService.init((portal, callback) => {
            if (portal) {
                app = portal;
            }

            if (window.location.pathname.includes('/ask-foremost')) {
                return;
            }

            const initESW = (gslbBaseURL) => {
                window.embedded_svc.settings.displayHelpButton = displayHelpButton;
                window.embedded_svc.settings.language = language;
                window.embedded_svc.settings.storageDomain = storageDomain;
                window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
                window.embedded_svc.settings.entryFeature = 'LiveAgent';


                window.embedded_svc.settings.directToButtonRouting = (prechatFormData) => {
                    for (let i = 0; i <= prechatFormData.length; i++) {
                        if (prechatFormData[i].label === 'Other Question') {
                            const buttonId = prechatFormData[i].value;
                            const res = buttonId.split('&');
                            return res[0];
                        }
                    }
                };
                window.embedded_svc.settings.prepopulatedPrechatFields = MLClickToChatDataService.getPrepopulatedPrechatFields(app);
                window.embedded_svc.settings.extraPrechatFormDetails = MLClickToChatDataService.getExtraPrechatFormDetails(app);
                window.embedded_svc.settings.extraPrechatInfo = MLClickToChatDataService.getExtraPrechatInfo(app);

                if (debugMode) {
                    console.dir('SF Click to Chat settings:');
                    console.dir(window.embedded_svc.settings);
                }

                window.embedded_svc.init(
                    MLClickToChatDataService.getSfUrl(),
                    MLClickToChatDataService.getLaUrl(),
                    gslbBaseURL,
                    MLClickToChatDataService.getOrgId(),
                    MLClickToChatDataService.getChatType(app),
                    MLClickToChatDataService.getDeploymentInfo(app)
                );
                if (callback) {
                    callback();
                }
            };

            if (!window.embedded_svc) {
                const s = document.createElement('script');
                s.setAttribute('src', MLClickToChatDataService.getScriptUrl());
                s.onload = () => {
                    initESW(null);
                };
                document.body.appendChild(s);
            } else {
                initESW('https://service.force.com');
            }
        }, p, c, auth);
    },
};